import { TranslateService } from '@ngx-translate/core';

function getBrowserLanguage(): string {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage.getItem('language') || 'it';
  }
  return 'it';
}

export function initTranslateService(translate: TranslateService): () => Promise<void> {
  return () => {
    const lang = getBrowserLanguage();
    translate.setDefaultLang(lang);
    return translate.use(lang).toPromise().then(() => {});
  };
}
